import React, { useEffect, useRef, useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { formatPercent } from 'utils';
import { emptyColor } from '../Utils/colors';
import { useTheme } from '@material-ui/core/styles';
import { tooltipStylePadded } from '../Tooltips/utils';
interface ValueProps {
  value: number;
  name: string;
  color: string;
  isHidden?: boolean;
}

const dummyData = [
  { value: 12, name: '1', color: '#e2e9f0' },
  { value: 4, name: '2', color: '#e2e9f0' },
  { value: 22, name: '3', color: '#e2e9f0' },
  { value: 41, name: '4', color: '#e2e9f0' },
  { value: 5, name: '5', color: '#e2e9f0' }
];

interface Props {
  data: ValueProps[];
  isAnimationActive?: boolean;
}

const TypicalAssetAllocation = ({ data, isAnimationActive = true }: Props) => {
  const theme = useTheme() as any;
  const isData = data
    ? data.reduce((acc: boolean, val: any) => {
        if (val.value !== 0) {
          acc = true;
        }
        return acc;
      }, false)
    : false;

  const dataToRender = isData ? data : dummyData;

  const containerRef = useRef(null) as any;
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        const { width } = containerRef.current.getBoundingClientRect();
        setWidth(width);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const radius = Math.min(width, 240) / 2; // Use the smaller of width or height
  const innerRadius = radius * 0.4; // 40% of the outer radius
  const outerRadius = radius * 0.8; // 80% of the available radius
  const paddingAngle = 2; // Keep this static or calculate dynamically if needed

  return (
    <div ref={containerRef} style={{ width: '100%', height: '240px' }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          {isData && (
            <Tooltip
              formatter={(val: any) => formatPercent(val)}
              contentStyle={tooltipStylePadded}
            />
          )}
          <Pie
            data={dataToRender}
            dataKey="value"
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            paddingAngle={paddingAngle}
            isAnimationActive={isAnimationActive}
          >
            {dataToRender.map((entry, index) => (
              <Cell
                key={index}
                fill={
                  isData
                    ? theme.palette.baseColors.charts['asset-allocation'][index]
                    : emptyColor
                }
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TypicalAssetAllocation;
